import { useCallback, useSyncExternalStore } from "react";
import { subscribeUserUiPreferenceStorage, userUiPreferenceStorage } from "../lib/userUiPreferenceStorage.js";

// La valeur brute reste stable entre deux changements ; la page et ses formulaires restent montés.
export default function useUserUiPreferenceStorageValue(kind, key) {
  const subscribe = useCallback((listener) => subscribeUserUiPreferenceStorage(kind, key, listener), [kind, key]);
  const snapshot = useCallback(() => userUiPreferenceStorage(kind)?.getItem(key) ?? null, [kind, key]);
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
